"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var outline_1 = require("@heroicons/react/24/outline");
var react_1 = require("@storyblok/react");
function IconPicker(_a) {
    var _b;
    var blok = _a.blok;
    var Component = {
        AcademicCapIcon: outline_1.AcademicCapIcon,
        AdjustmentsHorizontalIcon: outline_1.AdjustmentsHorizontalIcon,
        AdjustmentsVerticalIcon: outline_1.AdjustmentsVerticalIcon,
        ArchiveBoxArrowDownIcon: outline_1.ArchiveBoxArrowDownIcon,
        ArchiveBoxXMarkIcon: outline_1.ArchiveBoxXMarkIcon,
        ArchiveBoxIcon: outline_1.ArchiveBoxIcon,
        ArrowDownCircleIcon: outline_1.ArrowDownCircleIcon,
        ArrowDownLeftIcon: outline_1.ArrowDownLeftIcon,
        ArrowDownOnSquareStackIcon: outline_1.ArrowDownOnSquareStackIcon,
        ArrowDownOnSquareIcon: outline_1.ArrowDownOnSquareIcon,
        ArrowDownRightIcon: outline_1.ArrowDownRightIcon,
        ArrowDownTrayIcon: outline_1.ArrowDownTrayIcon,
        ArrowDownIcon: outline_1.ArrowDownIcon,
        ArrowLeftCircleIcon: outline_1.ArrowLeftCircleIcon,
        ArrowLeftOnRectangleIcon: outline_1.ArrowLeftOnRectangleIcon,
        ArrowLeftIcon: outline_1.ArrowLeftIcon,
        ArrowLongDownIcon: outline_1.ArrowLongDownIcon,
        ArrowLongLeftIcon: outline_1.ArrowLongLeftIcon,
        ArrowLongRightIcon: outline_1.ArrowLongRightIcon,
        ArrowLongUpIcon: outline_1.ArrowLongUpIcon,
        ArrowPathRoundedSquareIcon: outline_1.ArrowPathRoundedSquareIcon,
        ArrowPathIcon: outline_1.ArrowPathIcon,
        ArrowRightCircleIcon: outline_1.ArrowRightCircleIcon,
        ArrowRightOnRectangleIcon: outline_1.ArrowRightOnRectangleIcon,
        ArrowRightIcon: outline_1.ArrowRightIcon,
        ArrowSmallDownIcon: outline_1.ArrowSmallDownIcon,
        ArrowSmallLeftIcon: outline_1.ArrowSmallLeftIcon,
        ArrowSmallRightIcon: outline_1.ArrowSmallRightIcon,
        ArrowSmallUpIcon: outline_1.ArrowSmallUpIcon,
        ArrowTopRightOnSquareIcon: outline_1.ArrowTopRightOnSquareIcon,
        ArrowTrendingDownIcon: outline_1.ArrowTrendingDownIcon,
        ArrowTrendingUpIcon: outline_1.ArrowTrendingUpIcon,
        ArrowUpCircleIcon: outline_1.ArrowUpCircleIcon,
        ArrowUpLeftIcon: outline_1.ArrowUpLeftIcon,
        ArrowUpOnSquareStackIcon: outline_1.ArrowUpOnSquareStackIcon,
        ArrowUpOnSquareIcon: outline_1.ArrowUpOnSquareIcon,
        ArrowUpRightIcon: outline_1.ArrowUpRightIcon,
        ArrowUpTrayIcon: outline_1.ArrowUpTrayIcon,
        ArrowUpIcon: outline_1.ArrowUpIcon,
        ArrowUturnDownIcon: outline_1.ArrowUturnDownIcon,
        ArrowUturnLeftIcon: outline_1.ArrowUturnLeftIcon,
        ArrowUturnRightIcon: outline_1.ArrowUturnRightIcon,
        ArrowUturnUpIcon: outline_1.ArrowUturnUpIcon,
        ArrowsPointingInIcon: outline_1.ArrowsPointingInIcon,
        ArrowsPointingOutIcon: outline_1.ArrowsPointingOutIcon,
        ArrowsRightLeftIcon: outline_1.ArrowsRightLeftIcon,
        ArrowsUpDownIcon: outline_1.ArrowsUpDownIcon,
        AtSymbolIcon: outline_1.AtSymbolIcon,
        BackspaceIcon: outline_1.BackspaceIcon,
        BackwardIcon: outline_1.BackwardIcon,
        BanknotesIcon: outline_1.BanknotesIcon,
        Bars2Icon: outline_1.Bars2Icon,
        Bars3BottomLeftIcon: outline_1.Bars3BottomLeftIcon,
        Bars3BottomRightIcon: outline_1.Bars3BottomRightIcon,
        Bars3CenterLeftIcon: outline_1.Bars3CenterLeftIcon,
        Bars3Icon: outline_1.Bars3Icon,
        Bars4Icon: outline_1.Bars4Icon,
        BarsArrowDownIcon: outline_1.BarsArrowDownIcon,
        BarsArrowUpIcon: outline_1.BarsArrowUpIcon,
        Battery0Icon: outline_1.Battery0Icon,
        Battery100Icon: outline_1.Battery100Icon,
        Battery50Icon: outline_1.Battery50Icon,
        BeakerIcon: outline_1.BeakerIcon,
        BellAlertIcon: outline_1.BellAlertIcon,
        BellSlashIcon: outline_1.BellSlashIcon,
        BellSnoozeIcon: outline_1.BellSnoozeIcon,
        BellIcon: outline_1.BellIcon,
        BoltSlashIcon: outline_1.BoltSlashIcon,
        BoltIcon: outline_1.BoltIcon,
        BookOpenIcon: outline_1.BookOpenIcon,
        BookmarkSlashIcon: outline_1.BookmarkSlashIcon,
        BookmarkSquareIcon: outline_1.BookmarkSquareIcon,
        BookmarkIcon: outline_1.BookmarkIcon,
        BriefcaseIcon: outline_1.BriefcaseIcon,
        BugAntIcon: outline_1.BugAntIcon,
        BuildingLibraryIcon: outline_1.BuildingLibraryIcon,
        BuildingOffice2Icon: outline_1.BuildingOffice2Icon,
        BuildingOfficeIcon: outline_1.BuildingOfficeIcon,
        BuildingStorefrontIcon: outline_1.BuildingStorefrontIcon,
        CakeIcon: outline_1.CakeIcon,
        CalculatorIcon: outline_1.CalculatorIcon,
        CalendarDaysIcon: outline_1.CalendarDaysIcon,
        CalendarIcon: outline_1.CalendarIcon,
        CameraIcon: outline_1.CameraIcon,
        ChartBarSquareIcon: outline_1.ChartBarSquareIcon,
        ChartBarIcon: outline_1.ChartBarIcon,
        ChartPieIcon: outline_1.ChartPieIcon,
        ChatBubbleBottomCenterTextIcon: outline_1.ChatBubbleBottomCenterTextIcon,
        ChatBubbleBottomCenterIcon: outline_1.ChatBubbleBottomCenterIcon,
        ChatBubbleLeftEllipsisIcon: outline_1.ChatBubbleLeftEllipsisIcon,
        ChatBubbleLeftRightIcon: outline_1.ChatBubbleLeftRightIcon,
        ChatBubbleLeftIcon: outline_1.ChatBubbleLeftIcon,
        ChatBubbleOvalLeftEllipsisIcon: outline_1.ChatBubbleOvalLeftEllipsisIcon,
        ChatBubbleOvalLeftIcon: outline_1.ChatBubbleOvalLeftIcon,
        CheckBadgeIcon: outline_1.CheckBadgeIcon,
        CheckCircleIcon: outline_1.CheckCircleIcon,
        CheckIcon: outline_1.CheckIcon,
        ChevronDoubleDownIcon: outline_1.ChevronDoubleDownIcon,
        ChevronDoubleLeftIcon: outline_1.ChevronDoubleLeftIcon,
        ChevronDoubleRightIcon: outline_1.ChevronDoubleRightIcon,
        ChevronDoubleUpIcon: outline_1.ChevronDoubleUpIcon,
        ChevronDownIcon: outline_1.ChevronDownIcon,
        ChevronLeftIcon: outline_1.ChevronLeftIcon,
        ChevronRightIcon: outline_1.ChevronRightIcon,
        ChevronUpDownIcon: outline_1.ChevronUpDownIcon,
        ChevronUpIcon: outline_1.ChevronUpIcon,
        CircleStackIcon: outline_1.CircleStackIcon,
        ClipboardDocumentCheckIcon: outline_1.ClipboardDocumentCheckIcon,
        ClipboardDocumentListIcon: outline_1.ClipboardDocumentListIcon,
        ClipboardDocumentIcon: outline_1.ClipboardDocumentIcon,
        ClipboardIcon: outline_1.ClipboardIcon,
        ClockIcon: outline_1.ClockIcon,
        CloudArrowDownIcon: outline_1.CloudArrowDownIcon,
        CloudArrowUpIcon: outline_1.CloudArrowUpIcon,
        CloudIcon: outline_1.CloudIcon,
        CodeBracketSquareIcon: outline_1.CodeBracketSquareIcon,
        CodeBracketIcon: outline_1.CodeBracketIcon,
        Cog6ToothIcon: outline_1.Cog6ToothIcon,
        Cog8ToothIcon: outline_1.Cog8ToothIcon,
        CogIcon: outline_1.CogIcon,
        CommandLineIcon: outline_1.CommandLineIcon,
        ComputerDesktopIcon: outline_1.ComputerDesktopIcon,
        CpuChipIcon: outline_1.CpuChipIcon,
        CreditCardIcon: outline_1.CreditCardIcon,
        CubeTransparentIcon: outline_1.CubeTransparentIcon,
        CubeIcon: outline_1.CubeIcon,
        CurrencyBangladeshiIcon: outline_1.CurrencyBangladeshiIcon,
        CurrencyDollarIcon: outline_1.CurrencyDollarIcon,
        CurrencyEuroIcon: outline_1.CurrencyEuroIcon,
        CurrencyPoundIcon: outline_1.CurrencyPoundIcon,
        CurrencyRupeeIcon: outline_1.CurrencyRupeeIcon,
        CurrencyYenIcon: outline_1.CurrencyYenIcon,
        CursorArrowRaysIcon: outline_1.CursorArrowRaysIcon,
        CursorArrowRippleIcon: outline_1.CursorArrowRippleIcon,
        DevicePhoneMobileIcon: outline_1.DevicePhoneMobileIcon,
        DeviceTabletIcon: outline_1.DeviceTabletIcon,
        DocumentArrowDownIcon: outline_1.DocumentArrowDownIcon,
        DocumentArrowUpIcon: outline_1.DocumentArrowUpIcon,
        DocumentChartBarIcon: outline_1.DocumentChartBarIcon,
        DocumentCheckIcon: outline_1.DocumentCheckIcon,
        DocumentDuplicateIcon: outline_1.DocumentDuplicateIcon,
        DocumentMagnifyingGlassIcon: outline_1.DocumentMagnifyingGlassIcon,
        DocumentMinusIcon: outline_1.DocumentMinusIcon,
        DocumentPlusIcon: outline_1.DocumentPlusIcon,
        DocumentTextIcon: outline_1.DocumentTextIcon,
        DocumentIcon: outline_1.DocumentIcon,
        EllipsisHorizontalCircleIcon: outline_1.EllipsisHorizontalCircleIcon,
        EllipsisHorizontalIcon: outline_1.EllipsisHorizontalIcon,
        EllipsisVerticalIcon: outline_1.EllipsisVerticalIcon,
        EnvelopeOpenIcon: outline_1.EnvelopeOpenIcon,
        EnvelopeIcon: outline_1.EnvelopeIcon,
        ExclamationCircleIcon: outline_1.ExclamationCircleIcon,
        ExclamationTriangleIcon: outline_1.ExclamationTriangleIcon,
        EyeDropperIcon: outline_1.EyeDropperIcon,
        EyeSlashIcon: outline_1.EyeSlashIcon,
        EyeIcon: outline_1.EyeIcon,
        FaceFrownIcon: outline_1.FaceFrownIcon,
        FaceSmileIcon: outline_1.FaceSmileIcon,
        FilmIcon: outline_1.FilmIcon,
        FingerPrintIcon: outline_1.FingerPrintIcon,
        FireIcon: outline_1.FireIcon,
        FlagIcon: outline_1.FlagIcon,
        FolderArrowDownIcon: outline_1.FolderArrowDownIcon,
        FolderMinusIcon: outline_1.FolderMinusIcon,
        FolderOpenIcon: outline_1.FolderOpenIcon,
        FolderPlusIcon: outline_1.FolderPlusIcon,
        FolderIcon: outline_1.FolderIcon,
        ForwardIcon: outline_1.ForwardIcon,
        FunnelIcon: outline_1.FunnelIcon,
        GifIcon: outline_1.GifIcon,
        GiftTopIcon: outline_1.GiftTopIcon,
        GiftIcon: outline_1.GiftIcon,
        GlobeAltIcon: outline_1.GlobeAltIcon,
        GlobeAmericasIcon: outline_1.GlobeAmericasIcon,
        GlobeAsiaAustraliaIcon: outline_1.GlobeAsiaAustraliaIcon,
        GlobeEuropeAfricaIcon: outline_1.GlobeEuropeAfricaIcon,
        HandRaisedIcon: outline_1.HandRaisedIcon,
        HandThumbDownIcon: outline_1.HandThumbDownIcon,
        HandThumbUpIcon: outline_1.HandThumbUpIcon,
        HashtagIcon: outline_1.HashtagIcon,
        HeartIcon: outline_1.HeartIcon,
        HomeModernIcon: outline_1.HomeModernIcon,
        HomeIcon: outline_1.HomeIcon,
        IdentificationIcon: outline_1.IdentificationIcon,
        InboxArrowDownIcon: outline_1.InboxArrowDownIcon,
        InboxStackIcon: outline_1.InboxStackIcon,
        InboxIcon: outline_1.InboxIcon,
        InformationCircleIcon: outline_1.InformationCircleIcon,
        KeyIcon: outline_1.KeyIcon,
        LanguageIcon: outline_1.LanguageIcon,
        LifebuoyIcon: outline_1.LifebuoyIcon,
        LightBulbIcon: outline_1.LightBulbIcon,
        LinkIcon: outline_1.LinkIcon,
        ListBulletIcon: outline_1.ListBulletIcon,
        LockClosedIcon: outline_1.LockClosedIcon,
        LockOpenIcon: outline_1.LockOpenIcon,
        MagnifyingGlassCircleIcon: outline_1.MagnifyingGlassCircleIcon,
        MagnifyingGlassMinusIcon: outline_1.MagnifyingGlassMinusIcon,
        MagnifyingGlassPlusIcon: outline_1.MagnifyingGlassPlusIcon,
        MagnifyingGlassIcon: outline_1.MagnifyingGlassIcon,
        MapPinIcon: outline_1.MapPinIcon,
        MapIcon: outline_1.MapIcon,
        MegaphoneIcon: outline_1.MegaphoneIcon,
        MicrophoneIcon: outline_1.MicrophoneIcon,
        MinusCircleIcon: outline_1.MinusCircleIcon,
        MinusSmallIcon: outline_1.MinusSmallIcon,
        MinusIcon: outline_1.MinusIcon,
        MoonIcon: outline_1.MoonIcon,
        MusicalNoteIcon: outline_1.MusicalNoteIcon,
        NewspaperIcon: outline_1.NewspaperIcon,
        NoSymbolIcon: outline_1.NoSymbolIcon,
        PaintBrushIcon: outline_1.PaintBrushIcon,
        PaperAirplaneIcon: outline_1.PaperAirplaneIcon,
        PaperClipIcon: outline_1.PaperClipIcon,
        PauseCircleIcon: outline_1.PauseCircleIcon,
        PauseIcon: outline_1.PauseIcon,
        PencilSquareIcon: outline_1.PencilSquareIcon,
        PencilIcon: outline_1.PencilIcon,
        PhoneArrowDownLeftIcon: outline_1.PhoneArrowDownLeftIcon,
        PhoneArrowUpRightIcon: outline_1.PhoneArrowUpRightIcon,
        PhoneXMarkIcon: outline_1.PhoneXMarkIcon,
        PhoneIcon: outline_1.PhoneIcon,
        PhotoIcon: outline_1.PhotoIcon,
        PlayCircleIcon: outline_1.PlayCircleIcon,
        PlayPauseIcon: outline_1.PlayPauseIcon,
        PlayIcon: outline_1.PlayIcon,
        PlusCircleIcon: outline_1.PlusCircleIcon,
        PlusSmallIcon: outline_1.PlusSmallIcon,
        PlusIcon: outline_1.PlusIcon,
        PowerIcon: outline_1.PowerIcon,
        PresentationChartBarIcon: outline_1.PresentationChartBarIcon,
        PresentationChartLineIcon: outline_1.PresentationChartLineIcon,
        PrinterIcon: outline_1.PrinterIcon,
        PuzzlePieceIcon: outline_1.PuzzlePieceIcon,
        QrCodeIcon: outline_1.QrCodeIcon,
        QuestionMarkCircleIcon: outline_1.QuestionMarkCircleIcon,
        QueueListIcon: outline_1.QueueListIcon,
        RadioIcon: outline_1.RadioIcon,
        ReceiptPercentIcon: outline_1.ReceiptPercentIcon,
        ReceiptRefundIcon: outline_1.ReceiptRefundIcon,
        RectangleGroupIcon: outline_1.RectangleGroupIcon,
        RectangleStackIcon: outline_1.RectangleStackIcon,
        RocketLaunchIcon: outline_1.RocketLaunchIcon,
        RssIcon: outline_1.RssIcon,
        ScaleIcon: outline_1.ScaleIcon,
        ScissorsIcon: outline_1.ScissorsIcon,
        ServerStackIcon: outline_1.ServerStackIcon,
        ServerIcon: outline_1.ServerIcon,
        ShareIcon: outline_1.ShareIcon,
        ShieldCheckIcon: outline_1.ShieldCheckIcon,
        ShieldExclamationIcon: outline_1.ShieldExclamationIcon,
        ShoppingBagIcon: outline_1.ShoppingBagIcon,
        ShoppingCartIcon: outline_1.ShoppingCartIcon,
        SignalSlashIcon: outline_1.SignalSlashIcon,
        SignalIcon: outline_1.SignalIcon,
        SparklesIcon: outline_1.SparklesIcon,
        SpeakerWaveIcon: outline_1.SpeakerWaveIcon,
        SpeakerXMarkIcon: outline_1.SpeakerXMarkIcon,
        Square2StackIcon: outline_1.Square2StackIcon,
        Square3Stack3DIcon: outline_1.Square3Stack3DIcon,
        Squares2X2Icon: outline_1.Squares2X2Icon,
        SquaresPlusIcon: outline_1.SquaresPlusIcon,
        StarIcon: outline_1.StarIcon,
        StopCircleIcon: outline_1.StopCircleIcon,
        StopIcon: outline_1.StopIcon,
        SunIcon: outline_1.SunIcon,
        SwatchIcon: outline_1.SwatchIcon,
        TableCellsIcon: outline_1.TableCellsIcon,
        TagIcon: outline_1.TagIcon,
        TicketIcon: outline_1.TicketIcon,
        TrashIcon: outline_1.TrashIcon,
        TrophyIcon: outline_1.TrophyIcon,
        TruckIcon: outline_1.TruckIcon,
        TvIcon: outline_1.TvIcon,
        UserCircleIcon: outline_1.UserCircleIcon,
        UserGroupIcon: outline_1.UserGroupIcon,
        UserMinusIcon: outline_1.UserMinusIcon,
        UserPlusIcon: outline_1.UserPlusIcon,
        UserIcon: outline_1.UserIcon,
        UsersIcon: outline_1.UsersIcon,
        VariableIcon: outline_1.VariableIcon,
        VideoCameraSlashIcon: outline_1.VideoCameraSlashIcon,
        VideoCameraIcon: outline_1.VideoCameraIcon,
        ViewColumnsIcon: outline_1.ViewColumnsIcon,
        ViewfinderCircleIcon: outline_1.ViewfinderCircleIcon,
        WalletIcon: outline_1.WalletIcon,
        WifiIcon: outline_1.WifiIcon,
        WindowIcon: outline_1.WindowIcon,
        WrenchScrewdriverIcon: outline_1.WrenchScrewdriverIcon,
        WrenchIcon: outline_1.WrenchIcon,
        XCircleIcon: outline_1.XCircleIcon,
        XMarkIcon: outline_1.XMarkIcon,
    }[((_b = blok === null || blok === void 0 ? void 0 : blok.icon) === null || _b === void 0 ? void 0 : _b.icon) || 'PlusCircleIcon'];
    return ((0, jsx_runtime_1.jsx)(Component, __assign({}, (0, react_1.storyblokEditable)(blok), { color: blok.color || 'black', width: blok.width || 20, class: "".concat(blok.class), height: blok.height })));
}
exports.IconPicker = IconPicker;
